import {makeAutoObservable} from "mobx";
import {CountryModel} from "../../common/models/country";
import {NewCompanyDetailsModel} from "../models/company";
import {DetailInStore, IDetailInStore} from "./detailInStore";

export interface ICompanyStore {
    clearStore: () => void;
    createDetail: () => void;
    removeDetail: (detailId: number) => void;
    details: IDetailInStore[];
}

export class CompanyStore implements ICompanyStore {
    _details: IDetailInStore[] = [];

    constructor() {
        makeAutoObservable(this);

        this.createDetail();
    }

    createDetail() {
        this._details.push(new DetailInStore());
    }

    removeDetail(detailId: number) {
        this._details.splice(detailId, 1);
    }

    clearStore() {
        this._details = [];
        this.createDetail();
    }

    get details() {
        return this._details;
    }

    setCompanyStore(detailData: NewCompanyDetailsModel | null, countries: CountryModel[], detailId: number) {
        if (!detailData) {
            return;
        }
        const detailElement = new DetailInStore();
        if (countries.map(country => country.imoCode).includes(detailData.countryImoCode)) {
            detailElement.setCountryImoCode(detailData?.countryImoCode || "");
        }
        detailElement.setName(detailData?.name || "");
        detailElement.setStreet(detailData?.street || "");
        detailElement.setPostalCode(detailData?.postalCode || "");
        detailElement.setCity(detailData?.city || "");
        detailElement.setPhoneNo(detailData?.phoneNo || "");
        detailElement.setIsEditData(false);

        this.details[detailId] = detailElement;
    }
}